import React from 'react';
import PropTypes from 'prop-types';
import ReactPannellum from 'react-pannellum';

const PanoramicImage = ({ panoramicImg }) => {
	const { src } = panoramicImg;

	return (
		<ReactPannellum
			id="panoramic-image"
			sceneId="panoramicScene"
			config={{ autoLoad: true }}
			imageSource={src}
			style={{ width: '100%', aspectRatio: 'auto 2/1' }}
		/>
	);
};

PanoramicImage.propTypes = {
	panoramicImg: PropTypes.shape({
		src: PropTypes.string,
		thumbnail: PropTypes.string
	})
};

export default PanoramicImage;
